/**
 * How long the pointer has to hold still before a panel disclosure opens under it. The panel has one
 * hover-open delay — the asset-list pill's hover card and the mention picker's row preview both wait
 * it out — so two hovers a user meets in the same session never open at different speeds. A surface
 * that deliberately differs says why at its own call site rather than picking a third number.
 */
export const WORKSPACE_AGENT_HOVER_OPEN_DELAY_MS = 150;

/** Hover cards close on pointer leave; a short delay keeps keyboard focus hops into the card from dismissing it. */
export const WORKSPACE_AGENT_HOVER_CLOSE_DELAY_MS = 300;
